const userAreaOptions = [
  {
    value: "NORTHERN",
    label: "北區"
  },
  {
    value: "CENTRAL",
    label: "中區"
  },
  {
    value: "SOUTHERN",
    label: "南區"
  },
  {
    value: "EASTERN",
    label: "東區"
  },
  {
    value: "SURROUNDING",
    label: "外島區"
  }
]

export default userAreaOptions
